import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import { loginActions, alertActions, changePasswordActions } from "../actions";
import logo1 from "./../assets/images/Header_logo.png";
//import bgg from "./../assets/images/bgg.png";

class DeleteAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resendbtn: true,
      UserName: null,
      Password: null,
      loggedIn: false,
      eyeToggle: true,
      forgotModal: false,
      Otp: null,

      formError: {
        UserName: "",
        Password: "",
      },
      formForgotHeading: "Forgot Password",
      buttonLabel: "Submit",
      Email: "",
      forgotFormError: {
        Email: null,
      },
      btnlog: true,
    };
    this.formHandle = this.formHandle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.passwordToggle = this.passwordToggle.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.handleForgotChange = this.handleForgotChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.submitForgotForm = this.submitForgotForm.bind(this);
    this.setResend = this.setResend.bind(this);
  }

  componentDidMount() {
    sessionStorage.removeItem("LoggedInUser");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("UserData");
    sessionStorage.removeItem("UserRole");
    sessionStorage.removeItem("UserType");
    sessionStorage.removeItem("UserNameData");
    sessionStorage.removeItem("UserEmailData");
    sessionStorage.removeItem("UserMobileData");
    sessionStorage.removeItem("CompanyData");
    sessionStorage.removeItem("assignedPermissionsForUser");
  }

  handleChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    switch (name) {
      case "IsActive":
        value = event.target.checked;
        break;
      default:
        break;
    }
    this.formHandle(value, name);
    this.setState({ errors, [name]: value });
  }
  formHandle(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    switch (name) {
      case "UserName":
        if (value === null || value.length < 1) {
          errors.UserName = "Please enter your email-id.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            errors.userName = "Please enter valid email-id.";
          } else errors.UserName = null;
          /* eslint-enable */
        } else errors.UserName = null;
        break;
      case "Password":
        if (value === null || value.length < 1) {
          errors.Password = "Please enter password";
        } else errors.Password = null;
        break;
      default:
        break;
    }
    return IsValid;
  }

  passwordToggle() {
    this.setState({ eyeToggle: !this.state.eyeToggle });
  }

  submitForm(event, flag) {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.formHandle(val, key);
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      var formData;
      if (flag == "G") {
        formData = {
          Email: this.state.UserName,
          Password: this.state.Password,
          RequestType: 1,
        };
      } else if (flag == "L") {
        formData = {
          Email: this.state.UserName,
          Password: this.state.Password,
          RequestType: 2,
          //otp: this.state.Otp,
        };
      }

      this.props.DeleteAccountUser(formData);
    }
  }

  //to reset form
  formForgotReset() {
    this.setState({ Email: this.state.UserName });
    let errors = this.state.forgotFormError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
      return errors[key];
    });
  }
  //to open dialog
  openDialog() {
    this.setState({ visible: true, Email: this.state.Email });
    //this.formForgotReset();
  }
  //to hide function
  hideFunc() {
    this.setState({
      visible: false,
      buttonLabel: "Submit",
    });
    this.formForgotReset();
  }
  //to submit form
  submitForgotForm(event) {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.forgotFormError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForgotForm(val, key);
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      const formData = {
        Email: this.state.Email,
      };

      this.props.forgotPassword(formData);
    }
  }
  //to handle change
  handleForgotChange(event) {
    const { name, value } = event.target;
    let errors = this.state.forgotFormError;

    this.validateForgotForm(value, name);
    this.setState({ errors, [name]: value });
  }

  setResend() {
    if (
      this.props.res &&
      this.props.res.ResponseCode &&
      this.props.res.ResponseCode == "205"
    ) {
      this.setState({
        resendbtn: false,
      });
      return false;
    } else return true;
  }
  //to validate form
  validateForgotForm(value, name) {
    let errors = this.state.forgotFormError;
    let IsValid = true;

    switch (name) {
      case "Email":
        if (value == null || value.length < 1) {
          IsValid = false;
          errors.Email = "Please enter your email-id.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.Email = "Please enter valid email-id.";
          } else errors.Email = "";
          /* eslint-enable */
        } else errors.Email = "";
        break;
      default:
        break;
    }

    return IsValid;
  }
  render() {
    return (
      <>
        <section className="" style={{ padding: "0" }}>
          <div class="bg-layer">
            <div className="container-fluid loginbg">
              <div className="row">
                <div className="col-md-4">
                  <div className="">
                    {/* // <img src={bgg} className="img-fluid liginbg" /> */}
                  </div>
                </div>
                <div className="col-md-4 mt5">
                  <div className="form-wraper box-shadow">
                    <div className="login-logo">
                      <img src={logo1} className="" />
                    </div>
                    <hr />
                    <h5>ACCOUNT DELETION REQUEST</h5>
                    <hr />
                    <form
                      onSubmit={(e) => {
                        this.submitForm(e, "L");
                      }}
                      style={{ background: "none" }}
                    >
                      <div className="logingPassword">
                        <div className="input-group form-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="fa fa-user"></i>
                            </span>
                          </div>
                          <input
                            disabled={
                              this.props.res &&
                              this.props.res.ResponseCode &&
                              this.props.res.ResponseCode == "205"
                                ? true
                                : false
                            }
                            type="text"
                            placeholder="Email / Mobile No "
                            onChange={this.handleChange}
                            name="UserName"
                            className="form-control"
                            noValidate
                          />
                          <span className="focus-input100"></span>
                          {this.state.formError.UserName != null ? (
                            <div className="error1">
                              {this.state.formError.UserName}
                            </div>
                          ) : null}
                        </div>

                        <div className="input-group form-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="fa fa-lock"></i>
                            </span>
                          </div>
                          <input
                            disabled={
                              this.props.res &&
                              this.props.res.ResponseCode &&
                              this.props.res.ResponseCode == "205"
                                ? true
                                : false
                            }
                            type={this.state.eyeToggle ? "password" : "text"}
                            autoComplete="off"
                            onChange={this.handleChange}
                            placeholder="Password"
                            name="Password"
                            className="form-control"
                            noValidate
                          />
                          <span className="focus-input100 "></span>
                          <i
                            className={
                              this.state.eyeToggle
                                ? "pi pi-eye eye-design"
                                : "pi pi-eye-slash eye-design"
                            }
                            onClick={this.passwordToggle}
                          ></i>
                          {this.state.formError.Password != null ? (
                            <div className="error1">
                              {this.state.formError.Password}
                            </div>
                          ) : null}
                        </div>

                        <div
                          hidden={
                            this.props.res &&
                            this.props.res.ResponseCode &&
                            this.props.res.ResponseCode == "205"
                              ? false
                              : true
                          }
                          className="input-group form-group"
                        >
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i
                                class="fa fa-paper-plane"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                          <input
                            type="text"
                            placeholder="Enter OTP"
                            onChange={this.handleChange}
                            name="Otp"
                            className="form-control"
                            noValidate
                          />
                          <span className="focus-input100"></span>
                          {this.state.formError.Otp != null ? (
                            <div className="error1">
                              {this.state.formError.Otp}
                            </div>
                          ) : null}
                        </div>

                        {/* <div
                          className="forgot-pass text-right"
                          onClick={() =>
                            this.setState({
                              forgotModal: true,
                              Email: this.state.UserName,
                            })
                          }
                        >
                          Forgot Password
                        </div> */}

                        <div className="my-5 sub_button">
                          <button className="btn btn-primary1 btn-lg login-button">
                            Delete Account
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="">
                    {/* // <img src={bgg} className="img-fluid liginbg" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="holo-footer">&nbsp;</div>
        </section>

        <Dialog
          header="Forgot Password"
          visible={this.state.forgotModal}
          onHide={() => this.setState({ forgotModal: false })}
        >
          <h5 style={{ color: "#3F51B5" }}>Reset Password</h5>
          <p>Enter your Email and instructions will be sent to you!</p>
          <form onSubmit={this.submitForgotForm}>
            <input
              type="text"
              placeholder="Email Id"
              value={this.state.Email}
              onChange={this.handleForgotChange}
              name="Email"
              className="form-control"
              noValidate
            />
            {this.state.forgotFormError.Email != null ? (
              <div className="error">{this.state.forgotFormError.Email}</div>
            ) : null}
            <div className="col-md-12 mt-3 text-center">
              <Button
                label="Reset"
                className="btn btn-primary"
                type="submit"
                icon="pi pi-check"
                onClick={() => this.setState({ forgotModal: false })}
              />
            </div>
          </form>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res:
      state.login?.items && state.login?.items[0]
        ? state.login?.items[0]
        : null,
    resendbtn: state.login?.enable,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DeleteAccountUser: (login) =>
      dispatch(loginActions.DeleteAccountUser(login)),
    forgotPassword: (data) =>
      dispatch(changePasswordActions.forgotPassword(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
